/**
 * AttachmentPreview - Preview for image and PDF attachments
 */

import { useState } from 'react'
import { FileText, Download, X } from 'lucide-react'

interface AttachmentPreviewProps {
  url: string
  type: string
  name: string
  isOwnMessage: boolean
}

export default function AttachmentPreview({
  url,
  type,
  name,
  isOwnMessage
}: AttachmentPreviewProps) {
  const [showImageModal, setShowImageModal] = useState(false)
  const isImage = type.startsWith('image/')
  const isPDF = type === 'application/pdf'

  if (isImage) {
    return (
      <>
        <div
          onClick={() => setShowImageModal(true)}
          className="cursor-pointer rounded-lg overflow-hidden border border-white/20 hover:opacity-90 transition-opacity max-w-xs"
        >
          <img
            src={url}
            alt={name}
            className="w-full h-auto max-h-48 object-cover"
          />
        </div>

        {/* Full-size image modal */}
        {showImageModal && (
          <div
            onClick={() => setShowImageModal(false)}
            className="fixed inset-0 bg-black/80 z-[9999] flex items-center justify-center p-4"
          >
            <button
              onClick={() => setShowImageModal(false)}
              className="absolute top-4 right-4 text-white hover:text-gray-300 bg-black/50 rounded-full p-2"
            >
              <X className="w-6 h-6" />
            </button>
            <img
              src={url}
              alt={name}
              className="max-w-full max-h-full object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </>
    )
  }

  if (isPDF) {
    return (
      <a
        href={url}
        download={name}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-2 px-3 py-2 rounded-lg border transition-colors ${
          isOwnMessage
            ? 'bg-white/10 border-white/20 hover:bg-white/20 text-white'
            : 'bg-gray-50 border-gray-200 hover:bg-gray-100 text-gray-700'
        }`}
      >
        <FileText className="w-5 h-5 flex-shrink-0" />
        <span className="text-sm flex-1 truncate">{name}</span>
        <Download className="w-4 h-4 flex-shrink-0" />
      </a>
    )
  }

  return null
}
